// 預約風控守門員配置
export const appointmentRiskGuardConfig = {
  // 風險等級配置
  riskLevels: {
    high: {
      value: 'high',
      label: '高',
      color: 'red',
      tag: 'danger',
    },
    medium: {
      value: 'medium',
      label: '中',
      color: 'orange',
      tag: 'warning',
    },
    low: {
      value: 'low',
      label: '低',
      color: 'green',
      tag: 'success',
    },
    null: {
      value: null,
      label: '-',
      color: 'gray',
      tag: 'info',
    },
  },

  // 風險等級選項 (用於多選)
  riskLevelOptions: [
    { value: 'high', label: '高風險', color: 'red' },
    { value: 'medium', label: '中風險', color: 'orange' },
    { value: 'low', label: '低風險', color: 'green' },
  ],
}
